import api from "../Config/api";


export const getAllContractorPayments = async () => {
  const res = await api.get("/contractorPayment/");
  return res.data;
};

export const getContractorPaymentById = async (id) => {
  const res = await api.get(`/contractorPayment/?id=${id}`);
  return res.data;
};

export const getContractorPaymentByFilter = async ({
  contractor_id = "",
  from_date = "",
  to_date = "",
}) => {
  try {
    const params = new URLSearchParams();

    if (contractor_id) {
      params.append("contractor_id", contractor_id);
    }

    if (from_date) {
      params.append("from_date", from_date);
    }

    if (to_date) {
      params.append("to_date", to_date);
    }

    const queryString = params.toString();

    const res = await api.get(
      `/contractorPayment/${queryString ? `?${queryString}` : ""}`
    );

    return res.data;
  } catch (err) {
    throw err.response?.data || err;
  }
};

export const saveContractorPayment = async (data) => {
  const res = await api.post("/contractorPayment/", data, {
    headers: { "Content-Type": "application/json" },
  });

  return res.data;
};

export const updateContractorPayment = async (data) => {
  const res = await api.put("/contractorPayment/", data, {
    headers: { "Content-Type": "application/json" },
  });

  return res.data;
};

export const deleteContractorPayment = async (id) => {
  const res = await api.delete(`/contractorPayment/?id=${id}`);
  return res.data;
};